export const imagesLibPath = '/assets/images/';
